
import styled from 'styled-components'

import COLORS from 'constants/colors'
import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'


export const ConnectWrap = styled.div<{ img: string, isLoading: boolean }>`
  padding: ${LAYOUT.VERTICALSPACEMOBILE} 20px;
  background-image: url(${(props): string => props.img});
  background-size: cover;
  transition: all 0.5s linear;
  ${(props): string | false => props.isLoading && 'filter: blur(10px);'}
  &:last-of-type {
    border-bottom: none;
  }
`

export const ConnectContent = styled.div`
  margin: auto;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  ${MEDIA.medium`
    padding: ${LAYOUT.VERTICALSPACE} 20px;
  `}
`

export const ConnectItem = styled.div`
  background: ${COLORS.WHITE};
  padding: ${LAYOUT.PADDING};
  margin: 5px;
  max-width: 390px;
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    margin: 10px 0 5px;
  }
  ${MEDIA.medium`
    padding: 20px 20px 40px ;
    h3 {
      margin: 20px;
    }
  `}
`
